import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useWatch } from "react-hook-form";

import CloseIcon from "../../../assets/img/close-tab.svg";
import useStyles from "./styles";

const PassengerTab = ({
  isActive,
  index,
  showDelete,
  remove,
  setActiveIndex,
  errors,
  resetActiveIndex,
  passengersValues,
}) => {
  const { tab, active, deleteIcon, tabError } = useStyles();
  const passengersWatch = useWatch({ name: "passengers" });
  return (
    <Box
      className={`${tab} ${isActive && active}`}
      onClick={() => {
        setActiveIndex(index);
      }}
    >
      {!!errors.length && errors[index] && (
        <Box
          className={tabError}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography>!</Typography>
        </Box>
      )}
      <Typography variant="body2">
        {passengersValues[index]?.firstName ||
          passengersWatch[index]?.firstName || <>Passenger {index + 1}</>}
      </Typography>
      {showDelete && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className={deleteIcon}
          onClick={(e) => {
            e.stopPropagation();
            resetActiveIndex();
            remove(index);
          }}
        >
          <img src={CloseIcon} alt="close-icon" />
        </Box>
      )}
    </Box>
  );
};

export default PassengerTab;
